"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Avatar = _interopRequireDefault(require("../Avatar/Avatar"));
var _constants = require("../constants");
var CrewRowPlaceholder = function CrewRowPlaceholder(_ref) {
  var female = _ref.female,
    number = _ref.number;
  var gender = female ? 'Girl' : 'Guy';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "list--items__item flex flex-column flex-row@xs justify-between margin-bottom-md"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "list--item__left flex margin-right-sm"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "left margin-right-sm"
  }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    avatarSize: _constants.AVATAR_SIZES.MEDIUM,
    avatarType: _constants.AVATAR_TYPES.CIRCLE,
    avatarColor: _constants.AVATAR_COLORS.CONTRAST_LOW,
    image: {
      url: 'https://cdn.theyachtweek.com/assets/icons/user-icon.png',
      alt: 'place holder icon'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "right text-component"
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "d8-u-font-size-base d8-u-ls-sm d8-u-font-primary d8-u-font-weight-300 d8-u-no-transform"
  }, "".concat(gender, " ").concat(number)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-color-contrast-medium"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm"
  }, "Not added yet")))));
};
CrewRowPlaceholder.propTypes = {
  female: _propTypes["default"].bool,
  number: _propTypes["default"].number.isRequired
};
var _default = exports["default"] = CrewRowPlaceholder;